import { createFileRoute } from "@tanstack/react-router";
import LearnHub, { hubSchema } from "@/pages/learn/LearnHub";
export const Route = createFileRoute("/learn/")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Patient Education | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Plain-language guides on TMS, SAINT® TMS, accelerated TMS, Spravato®, treatment-resistant depression, and how depression treatments compare. Medically reviewed.",
        },
        {
          property: "og:title",
          content: "Patient Education | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Plain-language guides on TMS, SAINT® TMS, accelerated TMS, Spravato®, treatment-resistant depression, and how depression treatments compare. Medically reviewed.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/learn",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/learn",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(hubSchema),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <LearnHub />;
}
